import { default as _91_46_46_46slug_93RZqYI9visnMeta } from "/builds/common/airbaltic-com/bt-frontend-nuxt/pages/[...slug].vue?macro=true";
import { default as book_45flightLOTrmbhKVFMeta } from "/builds/common/airbaltic-com/bt-frontend-nuxt/pages/book-flight.vue?macro=true";
import { default as indexTLhFQU3CkjMeta } from "/builds/common/airbaltic-com/bt-frontend-nuxt/pages/index.vue?macro=true";
import { default as component_45stubRZ7YypkiNzMeta } from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/nuxt/dist/pages/runtime/component-stub?macro=true";
import { default as component_45stubRZ7YypkiNz } from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/nuxt/dist/pages/runtime/component-stub";
export default [
  {
    name: _91_46_46_46slug_93RZqYI9visnMeta?.name ?? "slug___en",
    path: _91_46_46_46slug_93RZqYI9visnMeta?.path ?? "/en/:slug(.*)*",
    meta: _91_46_46_46slug_93RZqYI9visnMeta || {},
    alias: _91_46_46_46slug_93RZqYI9visnMeta?.alias || [],
    redirect: _91_46_46_46slug_93RZqYI9visnMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93RZqYI9visnMeta?.name ?? "slug___lv",
    path: _91_46_46_46slug_93RZqYI9visnMeta?.path ?? "/lv/:slug(.*)*",
    meta: _91_46_46_46slug_93RZqYI9visnMeta || {},
    alias: _91_46_46_46slug_93RZqYI9visnMeta?.alias || [],
    redirect: _91_46_46_46slug_93RZqYI9visnMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93RZqYI9visnMeta?.name ?? "slug___lt",
    path: _91_46_46_46slug_93RZqYI9visnMeta?.path ?? "/lt/:slug(.*)*",
    meta: _91_46_46_46slug_93RZqYI9visnMeta || {},
    alias: _91_46_46_46slug_93RZqYI9visnMeta?.alias || [],
    redirect: _91_46_46_46slug_93RZqYI9visnMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93RZqYI9visnMeta?.name ?? "slug___de",
    path: _91_46_46_46slug_93RZqYI9visnMeta?.path ?? "/de/:slug(.*)*",
    meta: _91_46_46_46slug_93RZqYI9visnMeta || {},
    alias: _91_46_46_46slug_93RZqYI9visnMeta?.alias || [],
    redirect: _91_46_46_46slug_93RZqYI9visnMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93RZqYI9visnMeta?.name ?? "slug___et",
    path: _91_46_46_46slug_93RZqYI9visnMeta?.path ?? "/et/:slug(.*)*",
    meta: _91_46_46_46slug_93RZqYI9visnMeta || {},
    alias: _91_46_46_46slug_93RZqYI9visnMeta?.alias || [],
    redirect: _91_46_46_46slug_93RZqYI9visnMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93RZqYI9visnMeta?.name ?? "slug___fi",
    path: _91_46_46_46slug_93RZqYI9visnMeta?.path ?? "/fi/:slug(.*)*",
    meta: _91_46_46_46slug_93RZqYI9visnMeta || {},
    alias: _91_46_46_46slug_93RZqYI9visnMeta?.alias || [],
    redirect: _91_46_46_46slug_93RZqYI9visnMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93RZqYI9visnMeta?.name ?? "slug___ru",
    path: _91_46_46_46slug_93RZqYI9visnMeta?.path ?? "/ru/:slug(.*)*",
    meta: _91_46_46_46slug_93RZqYI9visnMeta || {},
    alias: _91_46_46_46slug_93RZqYI9visnMeta?.alias || [],
    redirect: _91_46_46_46slug_93RZqYI9visnMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93RZqYI9visnMeta?.name ?? "slug___uk",
    path: _91_46_46_46slug_93RZqYI9visnMeta?.path ?? "/uk/:slug(.*)*",
    meta: _91_46_46_46slug_93RZqYI9visnMeta || {},
    alias: _91_46_46_46slug_93RZqYI9visnMeta?.alias || [],
    redirect: _91_46_46_46slug_93RZqYI9visnMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: book_45flightLOTrmbhKVFMeta?.name ?? "book-flight___en",
    path: book_45flightLOTrmbhKVFMeta?.path ?? "/en/book-flight",
    meta: book_45flightLOTrmbhKVFMeta || {},
    alias: book_45flightLOTrmbhKVFMeta?.alias || [],
    redirect: book_45flightLOTrmbhKVFMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/book-flight.vue").then(m => m.default || m)
  },
  {
    name: book_45flightLOTrmbhKVFMeta?.name ?? "book-flight___lv",
    path: book_45flightLOTrmbhKVFMeta?.path ?? "/lv/rezervet-biletes",
    meta: book_45flightLOTrmbhKVFMeta || {},
    alias: book_45flightLOTrmbhKVFMeta?.alias || [],
    redirect: book_45flightLOTrmbhKVFMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/book-flight.vue").then(m => m.default || m)
  },
  {
    name: book_45flightLOTrmbhKVFMeta?.name ?? "book-flight___lt",
    path: book_45flightLOTrmbhKVFMeta?.path ?? "/lt/uzsakyti-skrydzius",
    meta: book_45flightLOTrmbhKVFMeta || {},
    alias: book_45flightLOTrmbhKVFMeta?.alias || [],
    redirect: book_45flightLOTrmbhKVFMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/book-flight.vue").then(m => m.default || m)
  },
  {
    name: book_45flightLOTrmbhKVFMeta?.name ?? "book-flight___de",
    path: book_45flightLOTrmbhKVFMeta?.path ?? "/de/fluge-buchen",
    meta: book_45flightLOTrmbhKVFMeta || {},
    alias: book_45flightLOTrmbhKVFMeta?.alias || [],
    redirect: book_45flightLOTrmbhKVFMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/book-flight.vue").then(m => m.default || m)
  },
  {
    name: book_45flightLOTrmbhKVFMeta?.name ?? "book-flight___et",
    path: book_45flightLOTrmbhKVFMeta?.path ?? "/et/broneerige-lend",
    meta: book_45flightLOTrmbhKVFMeta || {},
    alias: book_45flightLOTrmbhKVFMeta?.alias || [],
    redirect: book_45flightLOTrmbhKVFMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/book-flight.vue").then(m => m.default || m)
  },
  {
    name: book_45flightLOTrmbhKVFMeta?.name ?? "book-flight___fi",
    path: book_45flightLOTrmbhKVFMeta?.path ?? "/fi/varaa-lennot",
    meta: book_45flightLOTrmbhKVFMeta || {},
    alias: book_45flightLOTrmbhKVFMeta?.alias || [],
    redirect: book_45flightLOTrmbhKVFMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/book-flight.vue").then(m => m.default || m)
  },
  {
    name: book_45flightLOTrmbhKVFMeta?.name ?? "book-flight___ru",
    path: book_45flightLOTrmbhKVFMeta?.path ?? "/ru/kupit-aviabilety",
    meta: book_45flightLOTrmbhKVFMeta || {},
    alias: book_45flightLOTrmbhKVFMeta?.alias || [],
    redirect: book_45flightLOTrmbhKVFMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/book-flight.vue").then(m => m.default || m)
  },
  {
    name: book_45flightLOTrmbhKVFMeta?.name ?? "book-flight___uk",
    path: book_45flightLOTrmbhKVFMeta?.path ?? "/uk/bronyujte-aviakvitki",
    meta: book_45flightLOTrmbhKVFMeta || {},
    alias: book_45flightLOTrmbhKVFMeta?.alias || [],
    redirect: book_45flightLOTrmbhKVFMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/book-flight.vue").then(m => m.default || m)
  },
  {
    name: indexTLhFQU3CkjMeta?.name ?? "index___en",
    path: indexTLhFQU3CkjMeta?.path ?? "/en",
    meta: indexTLhFQU3CkjMeta || {},
    alias: indexTLhFQU3CkjMeta?.alias || [],
    redirect: indexTLhFQU3CkjMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexTLhFQU3CkjMeta?.name ?? "index___lv",
    path: indexTLhFQU3CkjMeta?.path ?? "/lv",
    meta: indexTLhFQU3CkjMeta || {},
    alias: indexTLhFQU3CkjMeta?.alias || [],
    redirect: indexTLhFQU3CkjMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexTLhFQU3CkjMeta?.name ?? "index___lt",
    path: indexTLhFQU3CkjMeta?.path ?? "/lt",
    meta: indexTLhFQU3CkjMeta || {},
    alias: indexTLhFQU3CkjMeta?.alias || [],
    redirect: indexTLhFQU3CkjMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexTLhFQU3CkjMeta?.name ?? "index___de",
    path: indexTLhFQU3CkjMeta?.path ?? "/de",
    meta: indexTLhFQU3CkjMeta || {},
    alias: indexTLhFQU3CkjMeta?.alias || [],
    redirect: indexTLhFQU3CkjMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexTLhFQU3CkjMeta?.name ?? "index___et",
    path: indexTLhFQU3CkjMeta?.path ?? "/et",
    meta: indexTLhFQU3CkjMeta || {},
    alias: indexTLhFQU3CkjMeta?.alias || [],
    redirect: indexTLhFQU3CkjMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexTLhFQU3CkjMeta?.name ?? "index___fi",
    path: indexTLhFQU3CkjMeta?.path ?? "/fi",
    meta: indexTLhFQU3CkjMeta || {},
    alias: indexTLhFQU3CkjMeta?.alias || [],
    redirect: indexTLhFQU3CkjMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexTLhFQU3CkjMeta?.name ?? "index___ru",
    path: indexTLhFQU3CkjMeta?.path ?? "/ru",
    meta: indexTLhFQU3CkjMeta || {},
    alias: indexTLhFQU3CkjMeta?.alias || [],
    redirect: indexTLhFQU3CkjMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexTLhFQU3CkjMeta?.name ?? "index___uk",
    path: indexTLhFQU3CkjMeta?.path ?? "/uk",
    meta: indexTLhFQU3CkjMeta || {},
    alias: indexTLhFQU3CkjMeta?.alias || [],
    redirect: indexTLhFQU3CkjMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/sitemap.xml",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/index-sitemap.xml",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/en-sitemap.xml",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/lv-sitemap.xml",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/lt-sitemap.xml",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/de-sitemap.xml",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/et-sitemap.xml",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/fi-sitemap.xml",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/ru-sitemap.xml",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/uk-sitemap.xml",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  }
]